// @ts-nocheck
/*import {
  SET_PLAYERS_WITH_FILTERS,
  SEARCH_PLAYER,
  SET_PLAYER,
  SET_PLAYERS_BY_TEAM,
  UPDATE_PLAYER
} from '../constants/actions';*/
import ActionTypes from '../constants/actions';
import Immutable from 'immutable';
import _ from 'lodash';

const defaultState = new Immutable.Map({});

export default (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.SET_PLAYERS_WITH_FILTERS:
      _.map(action.players, (player) => {
        state = state.set(player._id, player);
      });
      return state;
      break;
    case ActionTypes.SET_PLAYERS_BY_GAME:
    case ActionTypes.SET_PLAYERS_BY_TEAM:
      _.map(action.players, (player) => {
        state = state.set(player._id, player);
      });
      return state;
      break;
    case ActionTypes.SEARCH_PLAYER:
      _.map(action.players, (player) => {
        state = state.set(player._id, player);
      });
      return state;
      break;
    case ActionTypes.UPDATE_PLAYER:
    case ActionTypes.ADD_PLAYER:
    case ActionTypes.SET_PLAYER:
      console.log('ADD_PLAYER: ', state, action.player);
      if(action.player._id) state = state.set(action.player._id, action.player);
      console.log('ADD_PLAYER: ', state, action.player);
      return state;
      break;

    case ActionTypes.DELETE_PLAYER:
      return state.remove(action.player._id);
      console.log('DELETE_PLAYER');
      break;
    default:
      return state;
  }
};

